import React from 'react';

interface Props {
  anchorTags: { title: string; ref: string }[];
}

const TableOfContents = ({ anchorTags }: Props) => {
  const handleAnchorClick = (anchorRef) => {
    const targetAnchor = document.getElementById('anchortag-' + anchorRef);
    if (targetAnchor) {
      targetAnchor.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="bg-grey-5">
      <div>
        {anchorTags?.map(({ title, ref }, index) => {
          return (
            <a
              href="#"
              key={index}
              className="anchor"
              onClick={(e) => {
                e.preventDefault();
                handleAnchorClick(ref);
              }}
            >
              <div className="p-1">
                {title} --- {ref}
              </div>
            </a>
          );
        })}
      </div>
    </div>
  );
};

export default TableOfContents;
